/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const listSubGroupsParamsFirstMax = 100;

export const ListSubGroupsParams = zod.object({
  first: zod.int().min(1).max(listSubGroupsParamsFirstMax).optional(),
  after: zod.string().optional(),
});

export type ListSubGroupsParams = zod.input<typeof ListSubGroupsParams>;
export type ListSubGroupsParamsOutput = zod.output<typeof ListSubGroupsParams>;
